import { useEffect, useState } from 'react';
import './Form.scss';
import { load } from 'recaptcha-v3';
import cn from 'classnames';
// import useGeoLocation from 'react-ipgeolocation';
import Point17 from '../../assets/point17.png';

const FORM_URL = 'https://hooks.zapier.com/hooks/catch/12344184/2cv8sq1/';

const Form = ({ onClose }) => {
  const [isSuccess, setSuccess] = useState(false);
  const [isSending, setSending] = useState(false);
  // const location = useGeoLocation();
  const [phoneValue, setPhoneValue] = useState('');
  const [isAgree, setIsAgree] = useState(true);

  useEffect(() => {
    window.addEventListener('keydown', handlePress);
    document.body.classList.add('no-scroll');

    return () => {
      window.removeEventListener('keydown', handlePress);
    };
  }, []);

  const handleClose = () => {
    document.body.classList.remove('no-scroll');
    onClose();
    setSuccess(false);
  };

  const handlePress = e => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  const validateEmail = email => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const handleSend = e => {
    setSending(true);
    e.preventDefault();
    const name = document.querySelector('#name').value;
    const phone = document.querySelector('#phone').value;
    const email = document.querySelector('#email').value;
    const company = document.querySelector('#company').value || '';
    const timeline = document.querySelector('#timeline').value || '';
    const message = document.querySelector('#message_text').value || '';

    const values = {
      content: {
        name,
        company,
        email,
        phone,
        message,
        timeline,
      },
    };

    if (!!name && validateEmail(email)) {
      fetch(`${FORM_URL}`, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(() => {
        setSuccess(true);
        setTimeout(handleClose, 3500);
        setSending(false);
      });
    }
  };

  return (
    <div className={cn('popup', isSuccess && 'popup-success')}>
      {isSuccess ? (
        <div className='success'>
          <span className='form-close' onClick={handleClose}>
            <svg width='28' height='28' viewBox='0 0 28 28' fill='none'>
              <path d='M23.9006 23.8996L4.10156 4.10059' stroke='#4F4CE0' stroke-width='2' />
              <path d='M4.09945 23.8996L23.8984 4.10059' stroke='#4F4CE0' stroke-width='2' />
            </svg>
          </span>
          <span className='success-icon'>
            <img src={Point17} />
          </span>
          <span className='success-title'>Your Message Has Been Sent</span>
          <span className='success-text'>Thanks for reaching out! We’ll get back to you shortly.</span>
          <span className='success-close form-button'>Close</span>
        </div>
      ) : (
        <div className='form'>
          <span className='form-close' onClick={handleClose}>
            <svg width='28' height='28' viewBox='0 0 28 28' fill='none'>
              <path d='M23.9006 23.8996L4.10156 4.10059' stroke='#4F4CE0' stroke-width='2' />
              <path d='M4.09945 23.8996L23.8984 4.10059' stroke='#4F4CE0' stroke-width='2' />
            </svg>
          </span>
          <span className='form-title'>Find Next Great Hire</span>
          <form className='form-content'>
            <label className='form-label'>
              <span>
                Name <sup>*</sup>
              </span>
              <input minLength='1' required placeholder='' className='form-input' name='name' id='name' />
              <span className='form-error'>Name is required</span>
            </label>

            <label className='form-label'>
              <span>Company</span>
              <input placeholder=' ' className='form-input' name='company' id='company' />
            </label>

            <div className='form-row'>
              <label className='form-label'>
                <span>
                  Email <sup>*</sup>
                </span>
                <input
                  required
                  placeholder=' '
                  type='email'
                  minLength='1'
                  className='form-input'
                  name='email'
                  id='email'
                  pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
                />
                <span className='form-error'>Wrong email format</span>
              </label>

              <label className='form-label'>
                <span>Phone number</span>
                <input
                  value={phoneValue}
                  placeholder=' '
                  onChange={e => setPhoneValue(e.target.value)}
                  className='form-input'
                  name='phone'
                  id='phone'
                />
              </label>
            </div>

            {!!phoneValue && (
              <div className='form-agree'>
                <input type='checkbox' checked={isAgree} onChange={() => setIsAgree(!isAgree)} />
                <span className='form-agree-text'>
                  I agree to receive communications by text message about job application updates, interview scheduling, and
                  related recruiting information from NextDeavor. You may opt out by replying STOP or ask for more information by
                  replying HELP. Message frequency varies. Message and data rates may apply. You may review our Privacy Policy to
                  learn how your data is used.
                </span>
              </div>
            )}

            <label className='form-label'>
              <span>
                Message <sup>*</sup>
              </span>
              <textarea
                placeholder='Tell us what you’re looking for or how we can help'
                className='form-input form-textarea'
                name='message_text'
                id='message_text'
              />
            </label>

            <label className='form-label'>
              <span>What is your timeline?</span>
              <input placeholder=' ' className='form-input' name='timeline' id='timeline' />
            </label>

            <button
              type='submit'
              aria-disabled='true'
              disabled={isSending || (!isAgree && !!phoneValue)}
              className='form-button'
              onClick={handleSend}
            >
              Send Request
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Form;
